<template>
  <navbar
    position="fixed"
    type="info"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ close }">
      <router-link
        v-popover:popover1
        class="navbar-brand"
        to="/"
        @click.native="close"
      >
        SPAREONE Place
      </router-link>
    </template>
    <template slot="navbar-menu" slot-scope="{ close }">
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/profile"
          @click.native="close"
        >
          <i class="now-ui-icons design_app"></i>
          <p>Profile</p>
        </router-link>
      </li>
      <drop-down
        tag="li"
        title="Portfolio"
        icon="now-ui-icons files_single-copy-04"
        class="nav-item"
      >
        <nav-link to="/tech">
          <i class="now-ui-icons tech_laptop"></i> Technical Projects
        </nav-link>
        <nav-link to="/media">
          <i class="now-ui-icons media-1_button-play"></i> Media Contents
        </nav-link>
      </drop-down>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/gallery"
          @click.native="close"
        >
          <i class="now-ui-icons design_app"></i>
          <p>Gallery</p>
        </router-link>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="YouTube"
          data-placement="bottom"
          href="https://www.youtube.com/@ChangHyeon"
          target="_blank"
          @click="close"
        >
          <i class="fab fa-youtube"></i>
          <p class="d-lg-none d-xl-none">YouTube</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Github"
          data-placement="bottom"
          href="https://www.github.com/spareone1"
          target="_blank"
          @click="close"
        >
          <i class="fab fa-github"></i>
          <p class="d-lg-none d-xl-none">Github</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped>
:deep(.dropdown-menu .dropdown-item.active),
:deep(.dropdown-menu .dropdown-item.router-link-active),
:deep(.dropdown-menu .dropdown-item.router-link-exact-active) {
  background-color: #2ca8ff;
  color: #fff;
}

:deep(.dropdown-menu .dropdown-item:hover),
:deep(.dropdown-menu .dropdown-item:focus) {
  background-color: rgba(44, 168, 255, 0.14);
  color: #1683d8;
}

:deep(.dropdown-menu .dropdown-item.active:hover),
:deep(.dropdown-menu .dropdown-item.active:focus),
:deep(.dropdown-menu .dropdown-item.router-link-active:hover),
:deep(.dropdown-menu .dropdown-item.router-link-active:focus),
:deep(.dropdown-menu .dropdown-item.router-link-exact-active:hover),
:deep(.dropdown-menu .dropdown-item.router-link-exact-active:focus) {
  background-color: #2ca8ff;
  color: #fff;
}
</style>
